import React from "react";
import { Box } from "@mui/material";
import Notice from "../components/Notice";
import CalendarSection from "../components/Calendar";
import WorkProgress from "../components/WorkProgress";
import "./TopPage.scss";

const Top: React.FC = () => {
  return (
    <Box className="toppage-container">
      <Box sx={{ flex: 1, display: "flex", gap: 3 }}>
        <Notice />
        <CalendarSection />
      </Box>
      <WorkProgress />
    </Box>
  );
};

export default Top;
